import { gql } from '@apollo/client';

export const INSTALLATION_FRAGMENT = gql`
  fragment InstallationData on Installation {
    answers
    updatedAt
    updatedBy
  }
`;

export const installationQuery = gql`
  query installation($organizationId: Long) {
    installation(organizationId: $organizationId) {
      ...InstallationData
    }
  }
  ${INSTALLATION_FRAGMENT}
`;

export const installationAccessCodesQuery = gql`
  query installationAccessCodes($organizationId: Long) {
    installationAccessCodes(organizationId: $organizationId) {
      id
      name
      code
      createdAt
      revokedAt
    }
  }
`;

export const installationPhotosQuery = gql`
  query installationPhotos($organizationId: Long) {
    installationPhotos(organizationId: $organizationId) {
      fileName
      label
      url
      section
    }
  }
`;

export const installationDocumentQuery = gql`
  query installationDocument($organizationId: Long) {
    installationDocument(organizationId: $organizationId) {
      url
      generatedAt
      generatedBy
    }
  }
`;

export const installationPhotoUploadRequestQuery = gql`
  query installationPhotoUploadRequest(
    $organizationId: Long
    $section: String!
    $fileName: String!
    $contentType: String!
  ) {
    installationPhotoUploadRequest(
      organizationId: $organizationId
      section: $section
      fileName: $fileName
      contentType: $contentType
    ) {
      url
      fileName
    }
  }
`;

export const updateInstallationSectionMutation = gql`
  mutation updateInstallationSection($organizationId: Long, $section: String!, $answers: Json!) {
    updateInstallationSection(organizationId: $organizationId, section: $section, answers: $answers) {
      ...InstallationData
    }
  }
  ${INSTALLATION_FRAGMENT}
`;

export const confirmInstallationPhotoUploadMutation = gql`
  mutation confirmInstallationPhotoUpload(
    $organizationId: Long
    $section: String!
    $fileName: String!
    $label: String
  ) {
    confirmInstallationPhotoUpload(
      organizationId: $organizationId
      section: $section
      fileName: $fileName
      label: $label
    ) {
      ...InstallationData
    }
  }
  ${INSTALLATION_FRAGMENT}
`;

export const updateInstallationPhotoLabelMutation = gql`
  mutation updateInstallationPhotoLabel(
    $organizationId: Long
    $section: String!
    $fileName: String!
    $label: String
  ) {
    updateInstallationPhotoLabel(
      organizationId: $organizationId
      section: $section
      fileName: $fileName
      label: $label
    ) {
      ...InstallationData
    }
  }
  ${INSTALLATION_FRAGMENT}
`;

export const removeInstallationPhotoMutation = gql`
  mutation removeInstallationPhoto($organizationId: Long, $section: String!, $fileName: String!) {
    removeInstallationPhoto(organizationId: $organizationId, section: $section, fileName: $fileName) {
      ...InstallationData
    }
  }
  ${INSTALLATION_FRAGMENT}
`;

export const issueInstallationAccessCodeMutation = gql`
  mutation issueInstallationAccessCode($organizationId: Long, $name: String!) {
    issueInstallationAccessCode(organizationId: $organizationId, name: $name) {
      id
      name
      code
      createdAt
      revokedAt
    }
  }
`;

export const revokeInstallationAccessCodeMutation = gql`
  mutation revokeInstallationAccessCode($organizationId: Long, $id: Long!) {
    revokeInstallationAccessCode(organizationId: $organizationId, id: $id)
  }
`;

export const generateInstallationDocumentAsyncMutation = gql`
  mutation generateInstallationDocumentAsync($organizationId: Long) {
    generateInstallationDocumentAsync(organizationId: $organizationId)
  }
`;

export const installationDocumentReadySubscription = gql`
  subscription installationDocumentReady($organizationId: Long) {
    installationDocumentReady(organizationId: $organizationId) {
      hospitalId
      url
      error
    }
  }
`;
